import base from './base';
import axios from "axios";
import {objToFormData} from "../helpers";

export default class extends base {
    static get uri() {
        return 'visits';
    }

    static singleVisit(params) {
        return axios.post(`${this.uri}/single`, objToFormData(params));
    }
}
